import React, { useRef, useEffect, useCallback, useState} from 'react';
import {setTrackLengthChoice} from 'actions/index.js';
import {connect} from 'react-redux';

const TrackLengthBar = ({resolution, resizable, rowLength, color, track, row, setSize, size}) => { 
    const ref = useRef(undefined);

    let style = {
        backgroundColor: color,
        width: 16 * 33,
    };

    useEffect(() => {
        setSize(track.pattern.length(resolution));
    }, [resolution]);

    let arr = new Array(16).fill(0);

    return (
        <div ref={ref} style={style} className="track-length-bar">
          {arr.map((x, i) =>
                   <div 
                     onClick={() => setSize(row*16 + i + 1)}
                     className={size === row*16 + i + 1 ? "length-option selected" :
                                size < row * 16 + i + 1 ? "length-option disabled" : "length-option"}>
                     {row*16 + i+1}
                   </div>)}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      resolution: state.sequencer.displayResolution,
      size: state.tracks.trackLengthChoice
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSize: (c) => dispatch(setTrackLengthChoice(c))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackLengthBar);
